module.exports = __webpack_public_path__ + "static/media/class (1).6a42eef8.webp";